'use client';

import { useQuery } from '@tanstack/react-query';

import { cartQueryOptions } from '@/entities/cart/client';
import { formatCount, GOODS_FORMS } from '@/shared/lib/plural';
import { Icon } from '@/shared/ui/icon';
import { IconLink } from '@/shared/ui/icon-button';

/** Cart icon. The design has no visible counter; the count is announced in the accessible name. */
export function CartLink() {
  const cart = useQuery(cartQueryOptions());
  const count = cart.data?.itemsCount ?? 0;
  return (
    <IconLink
      href="/cart"
      label={count ? `Корзина, ${formatCount(count, GOODS_FORMS)}` : 'Корзина'}
    >
      <Icon name="bag" />
    </IconLink>
  );
}
